import React, { FunctionComponent } from 'react';
import Link from 'next/link';
import { Container } from 'react-bootstrap';
import BreadcrumbBoostrap from 'react-bootstrap/Breadcrumb';
import BreadcrumbItem from 'react-bootstrap/BreadcrumbItem';
import BreadcrumbWrapper from '@views/components/breadcrumb/Wrapper';

import cn from 'classnames';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';

export type TBreadcrumbProps = {
  options?: TBreadcrumbItemProps[];
};

export type TBreadcrumbItemProps = {
  active?: boolean;
  href?: string;
  as?: string;
  name: string;
};

export const Breadcrumb: FunctionComponent<TBreadcrumbProps> = ({
  options,
}) => {
  const length = options.length - 1;

  return (
    <BreadcrumbWrapper>
      <Container>
        <BreadcrumbBoostrap>
          <Link href="/" passHref>
            <BreadcrumbItem
              key={Symbol('home').toString()}
              className={cn(EVENT_CLASS_NAME)}
              data-category={EVENT_CATEGORY.BREADCRUMB}
              data-action={EVENT_ACTION_NAME}
              data-label="Văn phòng phẩm"
            >
              Văn phòng phẩm
              <svg
                className="breadcrumb-arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="8"
                viewBox="0 0 6 8"
              >
                <path d="M4 0l4 6H0z" transform="rotate(90 3 3)" />
              </svg>
            </BreadcrumbItem>
          </Link>

          {options.map(({ active, href, as, name }, index) =>
            active ? (
              <BreadcrumbItem
                active={active}
                key={Symbol(index).toString()}
                className={cn(EVENT_CLASS_NAME)}
                data-category={EVENT_CATEGORY.BREADCRUMB}
                data-action={EVENT_ACTION_NAME}
                data-label={name}
              >
                {name}
              </BreadcrumbItem>
            ) : (
              <Link passHref href={href} as={as} key={Symbol(index).toString()}>
                <BreadcrumbItem
                  className={cn(EVENT_CLASS_NAME)}
                  data-category={EVENT_CATEGORY.BREADCRUMB}
                  data-action={EVENT_ACTION_NAME}
                  data-label={name}
                >
                  {name}
                  {index < length && (
                    <svg
                      className="breadcrumb-arrow"
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="8"
                      viewBox="0 0 6 8"
                    >
                      <path d="M4 0l4 6H0z" transform="rotate(90 3 3)" />
                    </svg>
                  )}
                </BreadcrumbItem>
              </Link>
            )
          )}
        </BreadcrumbBoostrap>
      </Container>
    </BreadcrumbWrapper>
  );
};

Breadcrumb.defaultProps = {
  options: [],
};

export default Breadcrumb;
